<template>
    <div>
        <v-toolbar
            flat
            dense
            dark
            color="primary"
            extended
        >
            <v-toolbar-title>
                Salidas de farmacia
            </v-toolbar-title>

            <v-spacer/>

            <v-icon
                @click="list()"
            >
                mdi-sync
            </v-icon>
            <!--En el extended, agrega un boton para abrir el modal de surtir receta-->
            <template v-slot:extension>
                <v-btn
                    text
                    @click="abreSurtirReceta()"
                >
                    Surtir receta
                </v-btn>
            </template>
        </v-toolbar>

        <v-row>
            <v-col cols="12" sm="3">
                <div class="pa-2">
                    <v-text-field rounded filled dense v-model="params.fechaColectivoDe" label="Fecha DE"/>
                    <v-text-field rounded filled dense v-model="params.fechaColectivoA" label="Fecha A"/>
                    <v-text-field rounded filled dense v-model="params.area" label="Área"/>
                    <v-text-field rounded filled dense v-model="params.tipo" label="Tipo"/>
                    <v-text-field rounded filled dense v-model="params.concepto" label="Concepto"/>
                    <v-text-field rounded filled dense v-model="params.folio" label="Folio"/>
                </div>
                <div class="pa-2 d-flex justify-space-between">
                    <v-btn color="primary" @click="limpiar">Todos</v-btn>
                    <v-btn color="primary" @click="buscar">Buscar</v-btn>
                </div>
            </v-col>
            <v-col cols="12" sm="9">
                <v-data-table
                    :headers="headers"
                    :items="datos"
                    disable-sort
                    :footer-props="{
                        'items-per-page-options': [10, 20, 30, 40, 50]
                    }"
                    item-key="id"
                    :loading="loadingTabla"
                    :server-items-length='total'
                    :options.sync="optionsTable"
                >
                    <template v-slot:[`item.tipo`]="{ item }">
                        <v-icon v-if="item.tipoInsumo==2" color="purple">mdi-needle</v-icon>
                        <v-icon v-if="item.tipoInsumo==1" color="blue">mdi-pill</v-icon>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <div>
                            <div v-if="item.status==1">
                                <v-icon color="blue darken-4">mdi-text-box-edit-outline</v-icon>
                                <div>
                                    Nuevo
                                </div>
                            </div>
                            <div v-if="item.status==2">
                                <v-icon color="blue darken-4">mdi-check</v-icon>
                                <div>
                                    Confirmado
                                </div>
                            </div>
                            <div v-if="item.status==3">
                                <v-icon color="blue darken-4">mdi-thumb-up</v-icon>
                                <div>
                                    Autorizado
                                </div>
                            </div>
                            <div v-if="item.status==4">
                                <v-icon color="green">mdi-list-box-outline</v-icon>
                                <div>
                                    Sirviendo
                                </div>
                            </div>
                            <div v-if="item.status==5">
                                <v-icon color="green">mdi-eject</v-icon>
                                <div>
                                    Cerrado
                                </div>
                            </div>
                            <div v-if="item.status==6">
                                <v-icon color="red">mdi-cancel</v-icon>
                                <div>
                                    Cerrado
                                </div>
                            </div>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <surtir-receta
            :dialogModal.sync="surtirRecetaDialog"
            @guardado="list"
        />
    </div>
</template>

<script>
export default {
    components:{
        'surtir-receta':()=>import('@/components/farmacia/FarmaciaRecetaDirecta'),
    },
    mounted(){
        this.list();
    },
    data:()=>({
        params:{},
        loadingTabla:false,
        solicitudes:[],
        catalogoAreas:[],
        catalogoTipos:[],
        datos:[],
        total:0,

        surtirRecetaDialog:false,

        headers: [
            {text: '', value: 'tipo', sortable:false, align:"center"},
            {text: 'Folio', value: 'folio', sortable:false, align:"center"},
            {text: 'Fecha', value: 'dateCreated', sortable:false, align:"center"},
            {text: 'Area', value: 'areaNom', sortable:false, align:"center"},
            {text: 'Tipo', value: 'salidaTipoNom', sortable:false, align:"center"},
            {text: 'Estado', value: 'status', sortable:false, align:"center"},
        ],
        optionsTable:{},
    }),
    methods:{
        abreSurtirReceta(){
            this.surtirRecetaDialog = true
        },
        buscar(){
            console.log(this.params);
        },
        limpiar(){
            this.params = {};
        },
        async list(){
            this.loadingTabla = true
            this.params.start = (this.optionsTable.page-1 )*this.optionsTable.itemsPerPage,
            this.params.limit = this.optionsTable.itemsPerPage
            try{
                let req = await this.$http({
                    method:'GET',
                    url: '/comi/listSalidas',
                    params: this.params,
                })
                this.loadingTabla = false
                this.datos = req.data.root
                this.total = req.data.total
            } catch(err){
                this.loadingTabla = false
                this.$store.dispatch('security/revisaError',err)
            }
        },
    },
    watch:{
        optionsTable:{
            handler(){
                this.list()
            },
            deep:true
        }
    }

}
</script>

<style>

</style>